import * as ActionTypes from "constants/ActionTypes";
import * as CuepointPreviewActions from "actions/CuepointPreviewActions";
import * as Timings from "constants/Timings";

import { call, put, select, takeLatest } from "redux-saga/effects";
import { delay } from "redux-saga";

const getVisibleCuepointPreviewIndex = (state) =>
  state.cuepointPreviews.visibleIndex;

function* hideCuepointPreview(action) {
  const index = action.index;
  yield call(delay, Timings.CUEPOINT_PREVIEW_HIDE_TIMEOUT);
  const currentVisibleCuepointPreviewIndex = yield select(
    getVisibleCuepointPreviewIndex,
  );
  if (
    currentVisibleCuepointPreviewIndex === index &&
    currentVisibleCuepointPreviewIndex !== -1
  ) {
    yield put(CuepointPreviewActions.hideCuepointPreviews());
  }
}

export default function* cuepointVisibilitySaga() {
  yield takeLatest(
    ActionTypes.SET_VISIBLE_CUEPOINT_PREVIEW_INDEX,
    hideCuepointPreview,
  );
}
